import { useEffect, useState, useRef } from "react";
import IconSpeaker from "../../../Common/Icons/IconSpeaker";

interface IAudioPlayerButton {
  file?: File;
  url?: string;
}

export default function AudioPlayerButton(props: IAudioPlayerButton) {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const audioUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
    if (audioUrlRef.current && props.file) {
      URL.revokeObjectURL(audioUrlRef.current);
    }
    audioUrlRef.current = null;
    setPlaying(false);

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      if (audioUrlRef.current && props.file) {
        URL.revokeObjectURL(audioUrlRef.current);
      }
    };
  }, [props.file, props.url]);

  const initializeAudio = () => {
    if (audioRef.current) return audioRef.current;

    let audioUrl: string;
    if (props.file) {
      audioUrl = URL.createObjectURL(props.file);
      audioUrlRef.current = audioUrl;
    } else if (props.url) {
      audioUrl = props.url;
    } else {
      return null;
    }

    const audio = new Audio(audioUrl);
    audioRef.current = audio;

    const handleEnded = () => {
      audio.currentTime = 0;
      setPlaying(false);
    };

    audio.addEventListener("ended", handleEnded);

    return audio;
  };

  const handlePlayPause = () => {
    const audio = initializeAudio();
    if (!audio) return;

    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      audio.play().catch((error) => {
        console.error("Error playing audio:", error);
        setPlaying(false);
      });
      setPlaying(true);
    }
  };

  return (
    <div
      onClick={handlePlayPause}
      className="w-full h-full relative flex items-center justify-center cursor-pointer"
    >
      {playing && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="rounded-full bg-brij-Peach w-3/4 h-3/4 animate-ping" />
        </div>
      )}
      <div className="relative rounded-full fill-brij-Default bg-brij-Peach p-4 z-10">
        <IconSpeaker />
      </div>
    </div>
  );
}
